export interface RoomAuthorityCredentials {
  readonly browserCredential: string;
  readonly roomCapability?: string;
  readonly privateAccessCode?: string;
}

interface StoragePort {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

function storageKey(serverUrl: string, slug: string): string {
  return `2d-space.room-authority:${serverUrl}:${slug}`;
}

export function readRoomAuthority(
  storage: StoragePort,
  serverUrl: string,
  slug: string,
): RoomAuthorityCredentials | undefined {
  const value = storage.getItem(storageKey(serverUrl, slug));
  if (value === null) {
    return undefined;
  }
  try {
    const parsed: unknown = JSON.parse(value);
    if (typeof parsed !== 'object' || parsed === null) {
      return undefined;
    }
    const record = parsed as Readonly<Record<string, unknown>>;
    if (typeof record.browserCredential !== 'string' || record.browserCredential.length === 0) {
      return undefined;
    }
    return {
      browserCredential: record.browserCredential,
      ...(typeof record.roomCapability === 'string' && record.roomCapability.length > 0
        ? { roomCapability: record.roomCapability }
        : {}),
      ...(typeof record.privateAccessCode === 'string' && record.privateAccessCode.length === 6
        ? { privateAccessCode: record.privateAccessCode }
        : {}),
    };
  } catch {
    return undefined;
  }
}

export function writeRoomAuthority(
  storage: StoragePort,
  serverUrl: string,
  slug: string,
  credentials: RoomAuthorityCredentials,
): void {
  storage.setItem(storageKey(serverUrl, slug), JSON.stringify(credentials));
}

export function clearRoomAuthority(storage: StoragePort, serverUrl: string, slug: string): void {
  storage.removeItem(storageKey(serverUrl, slug));
}
